import { Platform } from "react-native"
import * as ExpoHaptics from "expo-haptics"

class Haptics {
  private static isWeb(): boolean {
    return Platform.OS === "web"
  }

  // Internal helpers (no public arg-taking API)
  private static async impactAsync(style: ExpoHaptics.ImpactFeedbackStyle): Promise<void> {
    if (Haptics.isWeb()) return
    await ExpoHaptics.impactAsync(style)
  }

  private static async selectionAsync(): Promise<void> {
    if (Haptics.isWeb()) return
    await ExpoHaptics.selectionAsync()
  }

  private static async notificationAsync(type: ExpoHaptics.NotificationFeedbackType): Promise<void> {
    if (Haptics.isWeb()) return
    await ExpoHaptics.notificationAsync(type)
  }

  // Convenience methods for each type
  static async impactLight(): Promise<void> {
    await Haptics.impactAsync(ExpoHaptics.ImpactFeedbackStyle.Light)
  }

  static async impactMedium(): Promise<void> {
    await Haptics.impactAsync(ExpoHaptics.ImpactFeedbackStyle.Medium)
  }

  static async impactHeavy(): Promise<void> {
    await Haptics.impactAsync(ExpoHaptics.ImpactFeedbackStyle.Heavy)
  }

  static async impactRigid(): Promise<void> {
    await Haptics.impactAsync(ExpoHaptics.ImpactFeedbackStyle.Rigid)
  }

  static async impactSoft(): Promise<void> {
    await Haptics.impactAsync(ExpoHaptics.ImpactFeedbackStyle.Soft)
  }

  static async selection(): Promise<void> {
    await Haptics.selectionAsync()
  }

  static async notificationSuccess(): Promise<void> {
    await Haptics.notificationAsync(ExpoHaptics.NotificationFeedbackType.Success)
  }

  static async notificationWarning(): Promise<void> {
    await Haptics.notificationAsync(ExpoHaptics.NotificationFeedbackType.Warning)
  }

  static async notificationError(): Promise<void> {
    await Haptics.notificationAsync(ExpoHaptics.NotificationFeedbackType.Error)
  }
}

export default Haptics


